import { AlertCircle, Info } from "lucide-react";
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { ScaledThumbnail } from "./ScaledThumbnail";

interface OverdueInvoicesMiniCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function OverdueInvoicesMiniCardThumbnail({
  isHovered = false,
  alwaysVisible = false,
}: OverdueInvoicesMiniCardThumbnailProps) {
  return (
    <ScaledThumbnail isHovered={isHovered} alwaysVisible={alwaysVisible}>
      <Card
        className="w-[300px]"
        style={{ borderLeft: "3px solid var(--mc-error-border)" }}
      >
        <CardContent className="p-4 flex flex-col gap-4">
          <div className="flex items-start justify-between gap-2">
            <div className="flex items-center gap-1 min-w-0">
              <span className="text-base font-medium text-neutral-800 truncate">
                Overdue Invoices
              </span>
              <Info className="h-3 w-3 text-muted-foreground flex-shrink-0" />
            </div>
            <div
              className="h-9 w-9 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: "var(--mc-error-bg)" }}
            >
              <AlertCircle
                className="h-4 w-4"
                style={{ color: "var(--mc-error-icon)" }}
              />
            </div>
          </div>

          <div>
            <div className="text-2xl font-bold text-neutral-900 tracking-tight">
              7
            </div>
            <div className="flex items-center gap-1 mt-1">
              <span className="text-xs font-semibold text-neutral-800">
                £28,450
              </span>
              <span className="text-xs font-normal text-neutral-800">
                total overdue
              </span>
            </div>
          </div>
        </CardContent>
      </Card>
    </ScaledThumbnail>
  );
}
